export const EDIT_CREDIT_CARD_START = 'EDIT_CREDIT_CARD_START';
export const EDIT_CREDIT_CARD_SUCCESS = 'EDIT_CREDIT_CARD_SUCCESS';
export const EDIT_CREDIT_CARD_ERROR = 'EDIT_CREDIT_CARD_ERROR';
export const EDIT_CREDIT_CARD_END = 'EDIT_CREDIT_CARD_END';
export const CLEAR_EDIT_CREDIT_CARD = 'CLEAR_EDIT_CREDIT_CARD_';
